import auth from '@/utils/authentication';
import { useEffect, useMemo, useState } from 'react';
// 静态路由保持不变
export const routes = [
// Dashboard - 一级页面
{
  name: 'menu.dashboard',
  key: 'dashboard',
  requiredPermissions: [{
    resource: 'dashboard',
    actions: ['view']
  }]
},
// Dashboard 模块权限（用于细粒度控制）
{
  name: 'menu.dashboard.financial_overview',
  key: 'dashboard.financial_overview',
  requiredPermissions: [{
    resource: 'dashboard.financial_overview',
    actions: ['view']
  }],
  ignore: true
}, {
  name: 'menu.dashboard.cash_flow',
  key: 'dashboard.cash_flow',
  requiredPermissions: [{
    resource: 'dashboard.cash_flow',
    actions: ['view']
  }],
  ignore: true
}, {
  name: 'menu.dashboard.recent_transactions',
  key: 'dashboard.recent_transactions',
  requiredPermissions: [{
    resource: 'dashboard.recent_transactions',
    actions: ['view']
  }],
  ignore: true
}, {
  name: 'menu.dashboard.pending_tasks',
  key: 'dashboard.pending_tasks',
  requiredPermissions: [{
    resource: 'dashboard.pending_tasks',
    actions: ['view']
  }],
  ignore: true
}, {
  name: 'menu.dashboard.account_summary',
  key: 'dashboard.account_summary',
  requiredPermissions: [{
    resource: 'dashboard.account_summary',
    actions: ['view']
  }],
  ignore: true
},
// General Ledger
{
  name: 'menu.general_ledger',
  key: 'general_ledger',
  requiredPermissions: [{
    resource: 'general_ledger',
    actions: ['view']
  }],
  children: [{
    name: 'menu.general_ledger.accounts',
    key: 'gl/accounts',
    requiredPermissions: [{
      resource: 'gl.accounts',
      actions: ['view']
    }]
  }, {
    name: 'menu.general_ledger.journal_entry',
    key: 'gl/journal-entry',
    requiredPermissions: [{
      resource: 'gl.journal_entry',
      actions: ['view']
    }],
    children: [{
      name: 'menu.general_ledger.journal_entry.create',
      key: 'gl/journal-entry/create',
      ignore: true,
      requiredPermissions: [{
        resource: 'gl.journal_entry',
        actions: ['create']
      }]
    }, {
      name: 'menu.general_ledger.journal_entry.view',
      key: 'gl/journal-entry/view/:id',
      ignore: true,
      // 不在菜单中显示
      requiredPermissions: [{
        resource: 'gl.journal_entry',
        actions: ['view']
      }]
    }]
  }, {
    name: 'menu.general_ledger.cashbook_entry',
    key: 'cashbooks/list',
    requiredPermissions: [{
      resource: 'gl.cashbook',
      actions: ['view']
    }]
  }, {
    name: 'menu.general_ledger.bank_reconciliation',
    key: 'gl/bank-reconciliation',
    requiredPermissions: [{
      resource: 'gl.bank_reconciliation',
      actions: ['view']
    }]
  }, {
    name: 'menu.general_ledger.bank_reconciliation_report',
    key: 'gl/bank-reconciliation-report',
    ignore: true,
    requiredPermissions: [{
      resource: 'gl.bank_reconciliation',
      actions: ['view']
    }]
  }, {
    name: 'menu.general_ledger.opening_balance',
    key: 'gl/opening-balance',
    requiredPermissions: [{
      resource: 'gl.opening_balance',
      actions: ['view']
    }]
  }, {
    name: 'menu.general_ledger.financial_year',
    key: 'gl/financial-year',
    requiredPermissions: [{
      resource: 'gl.financial_year',
      actions: ['view']
    }]
  }]
},
// Customers
{
  name: 'menu.customers',
  key: 'customers',
  requiredPermissions: [{
    resource: 'customers',
    actions: ['view']
  }],
  children: [{
    name: 'menu.customers.list',
    key: 'customers/list',
    requiredPermissions: [{
      resource: 'customers',
      actions: ['view']
    }]
  }, {
    name: 'menu.customers.customer_list',
    key: 'customers/customer-list',
    ignore: true,
    requiredPermissions: [{
      resource: 'customers',
      actions: ['view']
    }]
  }, {
    name: 'menu.customers.customer_form',
    key: 'customers/customer-list/form',
    ignore: true,
    requiredPermissions: [{
      resource: 'customers',
      actions: ['create', 'edit']
    }]
  }, {
    name: 'menu.customers.sales_invoice',
    key: 'customers/sales-invoice',
    requiredPermissions: [{
      resource: 'customers.sales_invoice',
      actions: ['view']
    }]
  }, {
    name: 'menu.customers.sales_invoice_demo',
    key: 'customers/sales-invoice-demo',
    ignore: true,
    requiredPermissions: [{
      resource: 'customers.sales_invoice',
      actions: ['view']
    }]
  }, {
    name: 'menu.customers.debit_note',
    key: 'customers/customer-debit-note',
    requiredPermissions: [{
      resource: 'customers.debit_note',
      actions: ['view']
    }]
  }, {
    name: 'menu.customers.credit_note',
    key: 'customers/customer-credit-note',
    requiredPermissions: [{
      resource: 'customers.credit_note',
      actions: ['view']
    }]
  }, {
    name: 'menu.customers.customer_receipt',
    key: 'customers/customer-receipt',
    requiredPermissions: [{
      resource: 'customers.receipt',
      actions: ['view']
    }]
  }]
},
// Suppliers
{
  name: 'menu.suppliers',
  key: 'suppliers',
  requiredPermissions: [{
    resource: 'suppliers',
    actions: ['view']
  }],
  children: [{
    name: 'menu.suppliers.list',
    key: 'suppliers/list',
    requiredPermissions: [{
      resource: 'suppliers',
      actions: ['view']
    }]
  }, {
    name: 'menu.suppliers.purchase_invoice',
    key: 'suppliers/purchase-invoice',
    requiredPermissions: [{
      resource: 'suppliers.purchase_invoice',
      actions: ['view']
    }]
  }, {
    name: 'menu.suppliers.debit_note',
    key: 'suppliers/debit-note',
    requiredPermissions: [{
      resource: 'suppliers.debit_note',
      actions: ['view']
    }]
  }, {
    name: 'menu.suppliers.credit_note',
    key: 'suppliers/credit-note',
    requiredPermissions: [{
      resource: 'suppliers.credit_note',
      actions: ['view']
    }]
  }, {
    name: 'menu.suppliers.supplier_payment',
    key: 'suppliers/supplier-payment',
    requiredPermissions: [{
      resource: 'suppliers.payment',
      actions: ['view']
    }]
  }]
},
// Reports
{
  name: 'menu.reports',
  key: 'reports',
  requiredPermissions: [{
    resource: 'reports',
    actions: ['view']
  }],
  children: [{
    name: 'menu.reports.general_ledger',
    key: 'reports/ledger-report',
    requiredPermissions: [{
      resource: 'reports.general_ledger',
      actions: ['view']
    }]
  }, {
    name: 'menu.reports.profit_loss',
    key: 'reports/profit-loss',
    requiredPermissions: [{
      resource: 'reports.profit_loss',
      actions: ['view']
    }]
  }, {
    name: 'menu.reports.trial_balance',
    key: 'reports/trial-balance',
    requiredPermissions: [{
      resource: 'reports.trial_balance',
      actions: ['view']
    }]
  }, {
    name: 'menu.reports.balance_sheet',
    key: 'reports/balance-sheet',
    requiredPermissions: [{
      resource: 'reports.balance_sheet',
      actions: ['view']
    }]
  }]
},
// Companies
{
  name: 'menu.companies',
  key: 'companies',
  requiredPermissions: [{
    resource: 'companies',
    actions: ['view']
  }],
  children: [{
    name: 'menu.companies.list',
    key: 'companies/list',
    requiredPermissions: [{
      resource: 'companies',
      actions: ['view']
    }]
  }, {
    name: 'menu.companies.department',
    key: 'companies/department',
    requiredPermissions: [{
      resource: 'companies.department',
      actions: ['view']
    }]
  }, {
    name: 'menu.companies.tax_codes',
    key: 'companies/tax-codes',
    requiredPermissions: [{
      resource: 'companies.tax_code',
      actions: ['view']
    }]
  }]
},
// System
{
  name: 'menu.system',
  key: 'system',
  requiredPermissions: [{
    resource: 'system',
    actions: ['view']
  }],
  children: [{
    name: 'menu.system.menus',
    key: 'system/menus',
    requiredPermissions: [{
      resource: 'system.menus',
      actions: ['view']
    }]
  }, {
    name: 'menu.system.users',
    key: 'system/users',
    requiredPermissions: [{
      resource: 'system.users',
      actions: ['view']
    }]
  }, {
    name: 'menu.system.roles',
    key: 'system/roles',
    requiredPermissions: [{
      resource: 'system.roles',
      actions: ['view']
    }]
  }, {
    name: 'menu.system.modules',
    key: 'system/modules',
    requiredPermissions: [{
      resource: 'system.modules',
      actions: ['view']
    }]
  }, {
    name: 'menu.system.permissions',
    key: 'system/permissions',
    requiredPermissions: [{
      resource: 'system.permissions',
      actions: ['view']
    }]
  }]
}];
export const getName = (path, routes) => {
  return routes.find(item => {
    const itemPath = `/${item.key}`;
    if (path === itemPath) {
      return item.name;
    } else if (item.children) {
      return getName(path, item.children);
    }
  });
};
const useRoute = (userPermission, dynamicMenus) => {
  const filterRoute = (routes, arr = []) => {
    if (!routes.length) {
      return [];
    }
    for (const route of routes) {
      const {
        requiredPermissions,
        oneOfPerm
      } = route;
      let visible = true;
      if (requiredPermissions) {
        visible = auth({
          requiredPermissions,
          oneOfPerm
        }, userPermission);
      }
      if (!visible) {
        continue;
      }
      if (route.children && route.children.length) {
        const newRoute = {
          ...route,
          children: []
        };
        filterRoute(route.children, newRoute.children);
        if (newRoute.children.length) {
          arr.push(newRoute);
        }
      } else {
        arr.push({
          ...route
        });
      }
    }
    return arr;
  };

  // 初始状态为空数组，避免权限过滤前显示所有菜单
  const [permissionRoute, setPermissionRoute] = useState([]);
  useEffect(() => {
    // 如果没有权限数据，不进行过滤（等待权限加载）
    if (!userPermission || Object.keys(userPermission).length === 0) {
      return;
    }

    // 处理动态菜单
    let finalRoutes = routes;
    if (dynamicMenus && dynamicMenus.length > 0) {
      // 将后台菜单数据转换为路由格式
      const dynamicRoutes = convertMenuToRoutes(dynamicMenus);
      // 合并静态路由和动态路由
      // finalRoutes = mergeRoutes(routes, dynamicRoutes);
      finalRoutes = mergeRoutes(routes, []);
    }
    const newRoutes = filterRoute(finalRoutes);
    setPermissionRoute(newRoutes);
  }, [JSON.stringify(userPermission), JSON.stringify(dynamicMenus)]);
  const defaultRoute = useMemo(() => {
    // 优先返回 Dashboard 作为默认首页（Dashboard 是一级页面，没有 children）
    const dashboard = permissionRoute.find(route => route.key === 'dashboard');
    if (dashboard) {
      return dashboard.key;
    }

    // 如果没有 Dashboard，则返回第一个路由
    const first = permissionRoute[0];
    if (first) {
      const firstRoute = first?.children?.[0]?.key || first.key;
      return firstRoute;
    }
    return '';
  }, [permissionRoute]);
  return [permissionRoute, defaultRoute];
};
export default useRoute;

// 添加将后台菜单数据转换为路由格式的函数
export const convertMenuToRoutes = menuData => {
  return menuData.map(menu => {
    const route = {
      name: menu.name,
      key: menu.key
    };

    // 如果有path属性，则添加到路由中
    if (menu.path) {
      route.path = menu.path;
    }

    // 如果有图标属性，则添加到路由中
    if (menu.icon) {
      route.icon = menu.icon;
    }

    // 如果设置了在新tab中打开，则添加到路由中
    if (menu.open_in_new_tab === 1 || menu.open_in_new_tab === true) {
      route.openInNewTab = true;
    }

    // 如果有子菜单，递归处理
    if (menu.children && menu.children.length > 0) {
      route.children = convertMenuToRoutes(menu.children);
    }
    return route;
  });
};

// 合并静态路由和动态路由的函数
export const mergeRoutes = (staticRoutes, dynamicRoutes) => {
  // 这里可以根据需要决定如何合并路由
  // 简单实现：将动态路由添加到静态路由之后
  return [...staticRoutes, ...dynamicRoutes];
};